// TODO: update to use controllerAs: $ctrl in tn.app.routeConfig.ts:home.checkout.billing
// TODO: convert to CheckoutBillingPageComponent and update router use the component.
import angular, { IFormController } from 'angular';
import { CartService, cartToGA4Items } from '../../tn.cart/service.tn.cart';
import { ScrollService } from '../../tn.common';
import {
    COUNTRIES,
    CartAddress,
    CartModel,
    FoundryService,
    ICartAddress,
    UserModel,
    dirtyfields as dirtyFields,
} from '../../tn.common';
import { GtmService } from '../../tn.common/classes/gtm/GtmService';
import { STATES } from '../../tn.common/constants/STATES';
import {
    StripeCard,
    StripeNewCreditCard,
    StripeService,
} from '../../tn.stripe/service.tn.stripe';
import { UserService } from '../../tn.user/service.tn.user';
import BillingService from '../service.tn.billing';
import { Pricing } from '../../tn.pricing/service.tn.pricing';
import { UIRouter } from 'angular-ui-router';

export interface SelectedCard {
    // string should be a stripe card id, null is unselected.
    // TODO: eliminate the 'card' property and just use
    // type SelectedCard = 'new' | 'invoice' | string | null;
    // and eventually replace with paymentMethod: 'invoice' | string | null;
    // and make the new card an independent form that adds to the paymentMethods array.
    card: 'new' | 'invoice' | string;
}

interface IBillingInfoScope extends angular.IScope {
    total: number;
    user?: UserModel;
    cc: StripeNewCreditCard;
    cart: CartModel;
    cardsLoaded: boolean; // inidicates that CCs have been loaded from stripe, and we can show the CC selection form.
    selectedCard: SelectedCard;
    ccError: unknown;
    savedccError: unknown;
    isLoggedIn: unknown;
    email: string;
    password: string;
    newsletters: unknown;
    // the selected licensee address
    licenseeAddress: ICartAddress;
    // the current data for the other license address form
    licenseeAddressOther: ICartAddress;
    // indicates that the licensee form is currently open and being edited
    licenseeEditingOpen: boolean;
    isLicenseeProfileComplete: boolean;
    licenseOwner: 'me' | 'other';
    userAddress: ICartAddress;
    billingAddress: ICartAddress;
    confirmButtonEnabled: boolean;
    isUserProfileComplete: boolean;
    isLargeOrder: boolean;
    billingLicenseeForm: IFormController;
    gotoOrderPlacement();
    saveCard: unknown;
    creditCards: unknown;
    billingInfoForm: IFormController;
    userProfileForm: IFormController;
    validPaymentMethod: boolean;
}

export function isBillingProfileComplete(user?: UserModel): boolean {
    return !!(
        user &&
        user.address1 &&
        user.first_name &&
        user.last_name &&
        user.country &&
        user.zipcode &&
        user.city &&
        user.email
    );
}

BillingInfo.$inject = [
    '$scope',
    '$scroll',
    'tn.user.service',
    'tn.billing.service',
    'tn.cart.service',
    'tn.stripe.service',
    'tn.pricing.service',
    'foundryService',
    'gtmService',
    '$uiRouter',
];

export default function BillingInfo(
    $scope: IBillingInfoScope,
    $scroll: ScrollService,
    userService: UserService,
    billingService: BillingService,
    cartService: CartService,
    stripeService: StripeService,
    pricingService: Pricing,
    foundryService: FoundryService,
    gtm: GtmService,
    $uiRouter: UIRouter
): void {
    const isLoggedIn = userService.isLoggedIn();
    const user = userService.getUser();
    const userAddress = cartService.mapUserToCartAddress(user);
    const licenseOwner = cartService.isLicensee(userAddress) ? 'me' : 'other';
    const isLicenseeProfileComplete = cartService.isLicenseeComplete();
    const licenseeAddressOther =
        licenseOwner == 'other' ? cartService.getLicensee() : new CartAddress();
    cartService.setBillingAddress(userAddress);
    const cart = cartService.getCart();

    angular.extend($scope, {
        cc: new StripeNewCreditCard(),
        cardLoaded: false,
        cart,
        user: userService.getUser(),
        userService: UserService,
        isLoggedIn,
        billingAddress: cartService.getBillingAddress(),
        userAddress,
        isUserProfileComplete: isBillingProfileComplete(user),
        licenseOwner,
        licenseeAddress: cartService.getLicensee(),
        licenseeAddressOther,
        licenseeEditingOpen: !isLicenseeProfileComplete,
        isLicenseeProfileComplete,
        creditCards: stripeService.getCards(),
        defaultCard: stripeService.getDefaultCard(),
        selectedCard: { card: '' },
        isLoginForm: true,
        newsletters: true,
        saveCard: true,
        confirmButtonEnabled: false,
        isLargeOrder: false,
        countries: COUNTRIES,
        states: STATES,

        next: next,
        gotoOrderPlacement() {
            // if we're leaving the billing page, we need to clear the cc form. We should leave that stuff lingering aroound.
            // I'm doing it here since all successful cc save paths end up here.
            resetCCForm();
            // track this to google analytics just before transitioning to order placement
            // there is an implicit assumpt that if we're going to order placement, payment info has been added.
            // this may need to move to multiple locations if that isn't true.
            trackAddPaymentInfo();
            $uiRouter.stateService.go('home.checkout.order');
        },
        login: login,
        loginErrors: {},
        logout() {
            userService.oauthLogout();
        },
        editLicensee: editLicensee,
        updateAddressFromZipcode(country, zipcode) {
            billingService.zipcodeLookup(country, zipcode);
        },
        saveUserInfo: saveUserInfo,
        saveLicenseeInfo: saveLicenseeInfo,
        getCountryFullName: getCountryFullName,
        cancelLicenseeEditing: cancelLicenseeEditing,
        setLicenseOwner: setLicenseOwner,
        initialize: initialize,
        canInvoice,
    });

    initialize();

    function initialize() {
        // handle auth state changes
        userService.user$.subscribe((user) => {
            if (user) {
                $scope.isLoggedIn = userService.isLoggedIn();
                $scope.user = user;
                $scope.isUserProfileComplete = isBillingProfileComplete(user);
                $scope.userAddress = cartService.mapUserToCartAddress(user);
                $scope.isLicenseeProfileComplete =
                    cartService.isLicenseeComplete();
                $scope.licenseeAddress = cartService.getLicensee();
                $scope.billingAddress = cartService.mapUserToCartAddress(
                    $scope.user
                );
                cartService.setBillingAddress($scope.billingAddress);
                $scope.cardsLoaded = false;
                stripeService
                    .getCardsFromStripe()
                    .then(() => ($scope.cardsLoaded = true));
                _checkBigOrder();
            } else {
                $scope.isUserProfileComplete = false;
                $scope.userAddress = new CartAddress();
                $scope.isLicenseeProfileComplete = false;
                $scope.billingAddress = new CartAddress();
                cartService.setBillingAddress($scope.billingAddress);
                $scope.cardsLoaded = false;
                stripeService.clearCards();
                $scope.licenseeAddressOther = new CartAddress();
                $scope.licenseeAddress = new CartAddress();
                _checkBigOrder();
            }
        });

        pricingService
            .calculateTotals($scope.cart.license, $scope.cart.coupon)
            .then((totals) => {
                $scope.total = totals.finals.withTax;
                _checkBigOrder();
            });

        $scope.$watch('saveCard', (saveCard) => {
            if (saveCard) {
                angular
                    .element('.form_section__payment .cc_default')
                    .removeClass('disabled')
                    .find('input')
                    .removeAttr('disabled');
            } else {
                $scope.cc.default = false;
                angular
                    .element('.form_section__payment .cc_default')
                    .addClass('disabled')
                    .find('input')
                    .attr('disabled', 'disabled');
            }
        });

        $scope.$watch('selectedCard.card', () => {
            $scope.validPaymentMethod = isPaymentMethodValid();
        });

        //display error parameters
        const $stateParams = $uiRouter.globals.params;
        if ($stateParams.error) {
            try {
                if (
                    $stateParams.error.type &&
                    $stateParams.error.type === 'stripe'
                ) {
                    if ($scope.selectedCard.card === 'new') {
                        $scope.ccError = _setParsedError();
                    } else {
                        saveUserInfo;
                        $scope.savedccError = _setParsedError();
                    }
                } else {
                    if ($scope.selectedCard.card === 'new') {
                        $scope.ccError = _setParsedError();
                    } else {
                        $scope.savedccError = _setParsedError();
                    }
                }
            } catch (e) {
                $scope.ccError =
                    'An error occured during payment; please update payment information and try again';
            }
            $scroll.to('form_section__payment');
        }

        // track analytics on goto billing info, start of checkout flow.
        foundryService.getDjangoFoundries().then(() => {
            const foundryIdx = foundryService.djangoFoundriesIdxByDjanoId;
            // we're showing the cart review page send the analytics events
            gtm.begin_checkout({
                currency: 'USD',
                value: 0,
                items: cartToGA4Items(foundryIdx, $scope.cart),
            });
        });
    }

    function _setParsedError() {
        const $stateParams = $uiRouter.globals.params;
        if (typeof $stateParams.error.error === 'string') {
            return JSON.parse($stateParams.error.error).message;
        }
        return 'An error occured during payment; please update payment information and try again';
    }

    function login() {
        // redirec to logout, but return to this state.
        const globals = $uiRouter.globals;
        userService.oauthLogin(globals.current.name, globals.params);
    }

    function editLicensee() {
        // callback for button to show edit licensee screen.
        // Reset the license info to me and an empty address object
        $scope.licenseeEditingOpen = true;
        $scope.licenseOwner = $scope.licenseOwner || 'me';
        $scope.billingLicenseeForm.$setPristine();
    }

    function saveUserInfo() {
        //Called when the user enters their profile, update this!
        const user: UserModel = Object.assign(
            {},
            $scope.user,
            $scope.userAddress
        );
        userService.saveUser(user).then(() => {
            // update the user on the scope.
            $scope.user = userService.getUser();
            $scope.isUserProfileComplete = isBillingProfileComplete(
                $scope.user
            );
            if ($scope.isUserProfileComplete) {
                $scope.billingAddress = cartService.mapUserToCartAddress(
                    $scope.user
                );
                cartService.setBillingAddress($scope.billingAddress);
            } else {
                dirtyFields($scope.userProfileForm);
            }
        });
    }

    function saveLicenseeInfo() {
        // Here we check who we're assigning license to, if it's "me" then copy the user's profile
        if ($scope.licenseOwner === 'me') {
            const userAddress = cartService.mapUserToCartAddress($scope.user);
            console.debug('setting licensee to user address', userAddress);
            cartService.setLicensee(userAddress);
        } else {
            console.debug(
                'setting licensee to other address',
                $scope.licenseeAddressOther
            );
            cartService.setLicensee($scope.licenseeAddressOther);
        }
        $scope.isLicenseeProfileComplete = cartService.isLicenseeComplete();
        // update local state
        $scope.licenseeAddress = cartService.getLicensee();
        // mark the license form to closed.
        $scope.licenseeEditingOpen = false;
        trackAddShippingInfo();
    }

    function getCountryFullName(shortName) {
        if (shortName) {
            const result = COUNTRIES.filter((o) => o.value === shortName)[0];
            if (result) {
                return result.label;
            }
        }
    }

    function cancelLicenseeEditing() {
        if (!$scope.isLicenseeProfileComplete) {
            // keep licensee editing open if it's not complete.
            $scope.licenseOwner = 'me';
            $scope.licenseeEditingOpen = true;
        } else {
            $scope.licenseeEditingOpen = false;
        }
    }

    function setLicenseOwner(newOwner) {
        $scope.licenseOwner = newOwner;
    }

    function canInvoice() {
        return $scope.total > 999 || userService.getUser()?.can_invoice;
    }

    function checkIsLargeOrder() {
        $scope.isLargeOrder = $scope.total >= 1000000;
        return $scope.isLargeOrder;
    }

    function _checkBigOrder() {
        // if the order is over a million, force set to invoice
        if (checkIsLargeOrder()) {
            if ($scope.isLoggedIn && userService.getUser()?.can_invoice) {
                $scope.selectedCard.card = 'invoice';
            } else {
                $uiRouter.stateService.go('home.checkout.review');
            }
        }
    }

    function isNewCardInputValid() {
        return (
            $scope.cc &&
            $scope.cc.number &&
            $scope.cc.isValid &&
            $scope.cc.CVC &&
            $scope.billingInfoForm.$valid
        );
    }

    function isSavedCardValid() {
        const card = stripeService.getCardById($scope.selectedCard.card);
        return !!card && !stripeService.isCardExpired(card);
    }

    function isPaymentMethodValid(): boolean {
        if ($scope.selectedCard.card === 'invoice') {
            return true;
        } else if ($scope.selectedCard.card === 'new') {
            // new cards are validated in next() before advancing to cart review, this method is primaryily
            // TODO: move new card generation to it's own method so it can be validated before enableing the
            // continue button.
            return true;
            // return isNewCardInputValid();
        } else {
            return isSavedCardValid();
        }
    }

    function resetCCForm() {
        $scope.cc.number = '';
        $scope.cc.expirationMonth = (new Date().getMonth() + 1) % 12;
        $scope.cc.expirationYear = new Date().getFullYear() - 2000;
        $scope.cc.CVC = '';
    }

    function next() {
        // Reset the cart state so we don't carry anything old further into the checkout process
        cartService.setInvoice(false);
        cartService.clearCard();
        cartService.clearStripeToken();

        // its fully discounted, no payment method is needed.
        if ($scope.total <= 0) {
            $scope.gotoOrderPlacement();
            return;
        }

        if ($scope.selectedCard.card === 'invoice') {
            cartService.setInvoice(true);
            $scope.gotoOrderPlacement();
            return;
        }

        if ($scope.selectedCard.card === 'new') {
            // If they're paying with a new card save it then navigate to the next stage
            // Clean any credit cart error messages before revalidating
            delete $scope.ccError;
            delete $scope.savedccError;

            // If there are validation errors then show them
            if (!isNewCardInputValid()) {
                //touch all fields to show errors
                dirtyFields($scope.billingInfoForm);
                // if (!$scope.cc.number) {
                //     $scope.ccError = 'Please enter a valid credit card number';
                // }
                if (!$scope.cc.isValid) {
                    $scope.ccError = 'Please enter a valid credit card number';
                }
                return;
            }

            // Otherwise set the address and licensee

            return stripeService
                .createTokenForCard($scope.cc, $scope.billingAddress)
                .then(
                    (
                        token: stripe.StripeCardTokenResponse & { vat?: string }
                    ) => {
                        if ($scope.saveCard) {
                            stripeService
                                .saveCard(token, $scope.billingAddress.vat)
                                .then(function (res) {
                                    if ($scope.cc.default) {
                                        stripeService.setDefaultCard(res.id);
                                    }
                                    copyCardBillingAddressToScopeBillingAddress();
                                    //get attach the new card to the cart
                                    cartService.setCard(res);
                                    // now that this is saved, navigation back to this page should
                                    // show this card as selected
                                    $scope.selectedCard.card = res.id;

                                    $scope.gotoOrderPlacement();
                                })
                                .catch(function (err) {
                                    if (err.data && err.data.error) {
                                        $scope.ccError = err.data.error.message;
                                        $scroll.to('newCreditCardDirective');
                                    }
                                });
                        } else {
                            // Save single use token to cart
                            copyCardBillingAddressToScopeBillingAddress();
                            cartService.setStripeToken(token);
                            this.cc = $scope.gotoOrderPlacement();
                        }
                    }
                )
                .catch(function (err) {
                    if (err.error) {
                        if (err.error.type && err.error.type === 'card_error') {
                            $scope.ccError = err.error.message;
                        } else {
                            $scope.ccError = err.error;
                        }
                        $scroll.to('newCreditCardDirective');
                    }
                });
        }

        const cardInstance = stripeService.getCardById(
            $scope.selectedCard.card
        );
        if (!cardInstance) {
            // TODO: show an error message, unrecognized card. We generally shouldn't get here.
            $scope.savedccError = `Unrecognized card. Please try again or contact support@typenetwork.com. Details: card_instance_not_found(${$scope.selectedCard.card})`;
            $scroll.to('savedCreditCardDirective');
            return;
        }

        if (stripeService.isCardExpired(cardInstance)) {
            $scope.savedccError =
                'This card has expired. Please update your card';
            $scroll.to('savedCreditCardDirective');
            return;
        }

        // looks like we're proceeding with a saved card
        copyCardBillingAddressToScopeBillingAddress();
        cartService.setCard(cardInstance);
        $scope.gotoOrderPlacement();
    }

    function trackAddShippingInfo() {
        // track analytics on goto billing info, start of checkout flow.
        foundryService.getDjangoFoundries().then(() => {
            const foundryIdx = foundryService.djangoFoundriesIdxByDjanoId;
            // we're showing the cart review page send the analytics events
            gtm.add_shipping_info({
                currency: 'USD',
                value: 0,
                items: cartToGA4Items(foundryIdx, $scope.cart),
            });
        });
    }

    function trackAddPaymentInfo() {
        // track analytics on goto billing info, start of checkout flow.
        foundryService.getDjangoFoundries().then(() => {
            const payment_type =
                $scope.selectedCard.card == 'invoice'
                    ? 'invoice'
                    : 'credit_card';
            const foundryIdx = foundryService.djangoFoundriesIdxByDjanoId;
            // we're showing the cart review page send the analytics events
            gtm.add_payment_info({
                payment_type,
                currency: 'USD',
                value: 0,
                items: cartToGA4Items(foundryIdx, $scope.cart),
            });
        });
    }

    function copyCardBillingAddressToScopeBillingAddress() {
        const card: StripeCard | undefined = stripeService.getCardById(
            $scope.selectedCard.card
        );
        if (card) {
            cartService.setCard(card);
            $scope.billingAddress.name = card.name;
            $scope.billingAddress.country = card.address_country;
            $scope.billingAddress.zipcode = card.address_zip;
            $scope.billingAddress.address1 = card.address_line1;
            $scope.billingAddress.address2 = card.address_line2;
            $scope.billingAddress.city = card.address_city;
            $scope.billingAddress.state = card.address_state;
            const vat = card.metadata.vat;
            if (vat) {
                $scope.billingAddress.vat = vat;
            }
        }
        cartService.setBillingAddress($scope.billingAddress);
    }
}
